var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"valuer_tool"}},[(!_vm.isRouteFullWidth)?_c('sidebar'):_vm._e(),_c('div',{class:{ 'full-width': _vm.isRouteFullWidth },attrs:{"id":"valuer_tool-content"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }